import React, { useEffect } from "react";
import firebase from "../fbConfig";

export const SignOut = (props) => {
  useEffect(() => {
    //console.log("Props:", props);
    firebase.auth().onAuthStateChanged((user) => {
      if (user != null && user.uid != null) {
        firebase.auth().signOut();
      } else {
        //console.log("Alredy Logged out");
        const queryParams = new URLSearchParams(window.location.search);
        const backurl = queryParams.get("backurl");
        if (backurl != null) {
          window.location.href = decodeURIComponent(backurl);
        } else {
          window.history.back();
        }
      }
    });
  }, []);
  return <div></div>;
};

export default SignOut;
